<template>
  <div v-if="isActive(type, getDataGroup(option)) && option !== 'textareaborder' || (type == 'mobile' && isMobile && getDataType(option) != 'arrows')" class="uyh-option-group" :data-group="getDataGroup(option)">
    <div v-if="(isMobile && getDataGroup(option) != 'image') || !isMobile" class="uyh-header" :class="{collapsable: isLandscapeTablet, 'mobile-header': isMobile}">
      <p>{{ $t('editor_tools.headers.' + option) }}</p>
    </div>

    <div v-if="isMobile && getDataGroup(option) == 'image' && getDataType(option) == 'range'" class="uyh-header" :class="{collapsable: isLandscapeTablet, 'mobile-header': isMobile}">
      <p>{{ $t('editor_tools.headers.imagescale') }}</p>
    </div>
    <div v-if="isMobile && getDataGroup(option) == 'image' && getDataType(option) == 'range'" class="uyh-select-group">
      <p>{{ $t('get_image.drag_and_zoom') }}</p>
    </div>

    <div v-if="getDataType(option) == 'swatch'" class="uyh-select-group uyh-swatch-group">
      <div class="uyh-swatch-wrapper" :style="{width: swatchCountToWidth(option)}">
        <button v-for="(swatch, index) in getData(option)"
                v-bind:style="{background: formatSwatch(swatch.swatch)}"
                v-bind:key="$t(swatch.title)"
                v-bind:title="$t(swatch.title)"
                @click="colorChange(swatch.swatch, option)"
                class="uyh-swatch"
                :class="{'active': isActive(swatch.swatch, getStore[option]), 'break-swatch': index === 4}">
        </button>

        <div v-if="getStore.options.includes('textareaborder') && option == 'textareacolor' && !isMobile" :style="{width: '100%'}">
          <div v-if="getDataType('textareaborder') == 'button'" class="uyh-select-group uyh-button-group" :style="{justifyContent: 'space-between', padding: '12.5px 4px', overflow: 'visible'}">
            <button v-for="button in getData('textareaborder')"
                    :key="button"
                    :title="$t('editor_tools.buttons.' + button)"
                    :class="{'active': isActive(getStore['textareaborder'], button), 'boldweight': button=='boldweight'}"
                    class="uyh-btn editor-btn small"
                    @click="handleButton('textareaborder', button)">
                    {{ $t('editor_tools.buttons.' + button) }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="(getDataType(option) == 'button' && option !== 'textareaborder') || (type == 'mobile' && isMobile && getDataGroup(option) != 'image')" class="uyh-select-group uyh-button-group">
      <button v-for="button in getData(option)"
              :key="button"
              :title="$t('editor_tools.buttons.' + button)"
              :class="{'active': isActive(getStore[option], button), 'boldweight': button=='boldweight'}"
              class="uyh-btn editor-btn"
              @click="handleButton(option, button)">
              {{ $t('editor_tools.buttons.' + button) }}
      </button>
    </div>

    <div v-else-if="getDataType(option) == 'range' && !isMobile" class="uyh-select-group uyh-range-group">
      <div class="range-wrapper">
        <button class="scale-button minus" @click="updateRange(-1)">&ndash;</button>
        <input type="range" min="-3" max="3" step="1" v-model="rangeChange" class="imageScale">
        <button class="scale-button" @click="updateRange(1)">&#43;</button>
      </div>
    </div>

    <div v-else-if="getDataType(option) == 'arrows' && !isMobile" class="uyh-select-group uyh-arrow-group">
      <div class="direction-wrapper">
        <button class="image-up arrow-button" @click="verticalMove(-1)">&uarr;</button>
      </div>
      <div class="direction-wrapper">
        <button class="image-left arrow-button" @click="horizontalMove(-1)">&larr;</button>
        <span class="center"></span>
        <button class="image-right arrow-button" @click="horizontalMove(1)">&rarr;</button>
      </div>
      <div class="direction-wrapper">
        <button class="image-down arrow-button" @click="verticalMove(1)">&darr;</button>
      </div>
    </div>
  </div>
</template>

<script>
  const rootHost = process.env.BASE_URL;

  export default {
    props: ["option", "type"],
    data: function() {
      return {
        rangeChange: 0,
        windowWidth: 0,
        isMobile: false,
        isLandscapeTablet: false,
        textareaborder: {
          data: [
            'noborder',
            'border'
          ],
          type: "button",
          group: "text"
        },
        textstyle: {
          data: [
            'mediumweight',
            'boldweight'
          ],
          type: "button",
          group: "text"
        },
        textcolor: {
          data: [
            {title: "swatch.pink", swatch: '#fc7ca0'},
            {title: "swatch.white", swatch: '#ffffff'},
            {title: "swatch.light_pink", swatch: '#f8baca'},
            {title: "swatch.green", swatch: '#223628'},
            {title: "swatch.grey", swatch: '#e0e9e7'},
          ],
          type: "swatch",
          group: "text"
        },
        textareacolor: {
          data: [
            {title: "swatch.pink", swatch: '#fc7ca0'},
            {title: "swatch.white", swatch: '#ffffff'},
            {title: "swatch.light_pink", swatch: '#f8baca'},
            {title: "swatch.green", swatch: '#223628'},
            {title: "swatch.grey", swatch: '#e0e9e7'},
            {title: "swatch.background_1", swatch: 'patterns/Pattern_1_Swatch.png'},
            {title: "swatch.background_2", swatch: 'patterns/Pattern_2_Swatch.png'},
            {title: "swatch.background_3", swatch: 'patterns/Pattern_3_Swatch.png'},
            {title: "swatch.background_4", swatch: 'patterns/Pattern_4_Swatch.png'}
          ],
          type: "swatch",
          group: "text"
        },
        primarybackground: {
          data: [
            {title: "swatch.pink", swatch: '#fc7ca0'},
            {title: "swatch.white", swatch: '#ffffff'},
            {title: "swatch.light_pink", swatch: '#f8baca'},
            {title: "swatch.green", swatch: '#223628'},
            {title: "swatch.grey", swatch: '#e0e9e7'},
            {title: "swatch.background_1", swatch: 'patterns/Pattern_1_Swatch.png'},
            {title: "swatch.background_2", swatch: 'patterns/Pattern_2_Swatch.png'},
            {title: "swatch.background_3", swatch: 'patterns/Pattern_3_Swatch.png'},
            {title: "swatch.background_4", swatch: 'patterns/Pattern_4_Swatch.png'},
            {title: "swatch.background_5", swatch: 'patterns/Pattern_5_Swatch.png'},
            {title: "swatch.background_6", swatch: 'patterns/Pattern_6_Swatch.png'}
          ],
          type: "swatch",
          group: "background"
        },
        secondarybackground: {
          data: [
            {title: "swatch.pink", swatch: '#fc7ca0'},
            {title: "swatch.white", swatch: '#ffffff'},
            {title: "swatch.light_pink", swatch: '#f8baca'},
            {title: "swatch.green", swatch: '#223628'},
            {title: "swatch.grey", swatch: '#e0e9e7'},
            {title: "swatch.background_1", swatch: 'patterns/Pattern_1_Swatch.png'},
            {title: "swatch.background_2", swatch: 'patterns/Pattern_2_Swatch.png'},
            {title: "swatch.background_3", swatch: 'patterns/Pattern_3_Swatch.png'},
            {title: "swatch.background_4", swatch: 'patterns/Pattern_4_Swatch.png'},
            {title: "swatch.background_5", swatch: 'patterns/Pattern_5_Swatch.png'},
            {title: "swatch.background_6", swatch: 'patterns/Pattern_6_Swatch.png'}
          ],
          type: "swatch",
          group: "background"
        },
        imagescale: {
          type: "range",
          group: "image"
        },
        imageposition: {
          type: "arrows",
          group: "image"
        }
      }
    },
    methods: {
      horizontalMove: function(value) {
        this.$emit('horizontal-move', value);
        this.$emit('enable-reset');
      },
      verticalMove: function(value) {
        this.$emit('vertical-move', value);
        this.$emit('enable-reset');
      },
      isActive: function(stringA, stringB) {
        if (stringB.includes('_640X640')) {
          stringA = stringA.split('_Swatch')[0];
          stringB = stringB.split('_640X640')[0];
        }
        return stringA == stringB;
      },
      widowWidth: function() {
        this.windowWidth = window.innerWidth;
      },
      isMobileFunction: function() {
        var maxWidth = 1023;
        if (window.innerWidth <= maxWidth) {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
      },
      isLandscapeTabletFunction: function() {
        var minWidth = 1024;
        var maxWidth = 1199;
        if (minWidth <= window.innerWidth && window.innerWidth <= maxWidth) {
          this.isLandscapeTablet = true;
        } else {
          this.isLandscapeTablet = false;
        }
      },
      handleButton: function(target, value) {
        this.$emit('enable-reset');
        this.$store.dispatch('handleButton', {
          target: target,
          value: value
        });
      },
      formatSwatch: function(swatch) {
        if (swatch.includes('patterns')) {
          return 'url(' + rootHost + swatch + ')';
        } else {
          return swatch;
        }
      },
      colorChange: function(backgroundSetting, backgroundTarget) {
        // Format if URL
        if (backgroundSetting.includes('/patterns')) {
          backgroundSetting = rootHost + backgroundSetting.replace('_Swatch', '_640X640');
        }
        this.$store.dispatch('updateBackgroundState', {
          background: backgroundTarget,
          value: backgroundSetting
        });
        this.$emit('enable-reset');
      },
      textboxBorderChange: function(borderStatus){
        this.$store.dispatch('updateBorder', {
          border: borderStatus
        });
      },
      getDataType: function(option) {
        return this[option].type;
      },
      getData: function(option) {
        return this[option].data;
      },
      getDataGroup: function(option) {
        return this[option].group;
      },
      swatchCountToWidth: function(option) {
        return (66 * this[option].data.length).toString() + 'px';
      },
      updateRange: function(value) {
        this.rangeChange = this.rangeChange + value;
      }
    },
    mounted: function() {
      this.widowWidth();
      this.isMobileFunction();
      this.isLandscapeTabletFunction();

      window.addEventListener('resize', this.widowWidth);
      window.addEventListener('resize', this.isMobileFunction);
      window.addEventListener('resize', this.isLandscapeTabletFunction);

      this.$nextTick(function() {
        this.mantraException;
      });
    },
    computed: {
      // eslint errors suppresed in order to prevent certain swatches from being displayed
      // eslint-disable-next-line
      mantraException: function() {
        var mantraid = this.$route.params.mantraId;
        if (mantraid == '12') {
          // eslint-disable-next-line
          this.textareacolor.data = this.textareacolor.data.slice(0,5);
        }
      },
      getStore() {
        return {
          primarybackground: this.$store.state.primarybackground,
          secondarybackground: this.$store.state.secondarybackground,
          textareacolor: this.$store.state.textareacolor,
          textcolor: this.$store.state.textcolor,
          textstyle: this.$store.state.textstyle,
          textareaborder: this.$store.state.textareaborder,
          message: this.$store.state.message,
          hashtag: this.$store.state.hashtag,
          icon: this.$store.state.icon,
          options: this.$store.state.options
        }
      }
    },
    watch: {
      rangeChange: function(val){
        this.$emit('scale-change', parseFloat(val));
        this.$emit('enable-reset');
      }
    },
    destroyed: function() {
      document.removeEventListener('resize', this.widowWidth);
      document.removeEventListener('resize', this.isMobileFunction);
      document.removeEventListener('resize', this.isLandscapeTabletFunction);
    }
  }
</script>
